import secureLocalStorage from "react-secure-storage";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { GridCell } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import React from "react";
import { toastr } from "react-redux-toastr";

export default class ActionAlertstackHolderComponent extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      stackHolder: [],
    };
    this.onTagsChange = this.onTagsChange.bind(this);
  }
  componentDidMount() {
    let data = this.props.dataItem[this.props.field];
    let value = this.processInput(data);
    if (value && value.length > 0) {
      this.handleChange("init", value);
    }
  }
  processInput(input) {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  handleChange = (e, values) => {
    this.setState({ stackHolder: values });
    if (values && values.length > 0 && e != "init") {
      this.whitespace(values);
    }
  };
  whitespace = (values) => {
    try {
      let mailvalidity =
        /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;
      var input = values[values.length - 1];

      if (
        input.trim().length == 0 ||
        input.length == 0 ||
        (!(input.includes("(") && input.includes(")")) &&
          mailvalidity.test(input) == false)
      ) {
        toastr.error("Please enter a valid email address");

        var stackHolder = values.splice(0, values.length - 1);
        this.setState({ ...this.state, stackHolder: stackHolder });
      } else {
        this.setState({ stackHolder: values });
      }
    } catch (err) {
      console.error(err);
    }
  };

  onTagsChange(e) {
    try {
      let emailList = [];

      this.state.stackHolder.map((item) => {
        let emailobj = this.props.stackeHolderList.filter(
          (data) => data.displayName == item || data.email == item
        );
        if (emailobj && emailobj.length > 0) {
          let val = emailobj[0].email;
          emailList.push(val);
        } else {
          emailList.push(item);
        }
      });

      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: emailList,
      });

      this.closePopup();
      // this.props.updateValue(emailList);
    } catch (err) {
      console.error(err);
    }
  }
  handleEditCell = () => {
    if (this.props.dataItem.isOpen === "Open" || this.props.dataItem.isOpen===true) {
      if (this.props.dataItem.riskRegisterActionId) {
        this.props.onEditCell(this.props.dataItem, this.props.field);
      }
    }
  };
  closePopup = () => {
    this.props.exitEdit();
  };
  render() {
    const { dataItem, field } = this.props;
    const value = this.props.dataItem[this.props.field];
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const riskOwnerId = this.props.riskDetails
      ? this.props.riskDetails.userId
      : null;

    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
      // console.log("if")
      return (
        <td>
          <Popup
            show={this.props.field === this.props.dataItem.inEdit}
            popupClass={"popup-content"}
          >
            <div className="deleteModelCont stackHolderSelection">
              <label className="fieldLabel">Select Stakeholders</label>
              <br></br>
              <p style={{ color: "#ffffff" }}>
                Please click on the box below to add the stakeholders. Please
                remember to press the "Enter" key after typing in each external
                stakeholder email address and ensure all email address(es) are
                highlighted before you click 'Submit'.
              </p>
              <Autocomplete
                multiple
                id="emailbcc"
                //   autoSelect={true}
                options={this.props.stackeHolderList.map(
                  (option) => option.displayName
                )}
                freeSolo
                disableCloseOnSelect
                onChange={this.handleChange}
                value={this.state.stackHolder}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                PaperComponent={({ children }) => (
                  <div className="paperComponent">
                    <span>{children}</span>
                  </div>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="filled" />
                )}
              />

              <div className="btnCont">
                <button
                  className="deleteBtn"
                  type="button"
                  onClick={this.onTagsChange}
                >
                  Submit
                </button>
                <button
                  onClick={this.closePopup}
                  className="cancelBtn"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
        </td>
      );
    }

    if (this.props.dataItem.inEdit !== this.props.field) {
      if (
        (loginUserId === ownerId || loginUserId === riskOwnerId) &&
        this.props.dataItem.isOpen === true
      ) {
        return (
          <td onClick={this.handleEditCell} title={value}>
            <span>{value}</span>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ||
          this.props.dataItem.isOpen == false ? (
          <td title={value}>
            <span>{value}</span>
          </td>
        ) : (
          <td onClick={this.handleEditCell} title={value}>
            <span>{value}</span>
          </td>
        );
      }
    }
  }
}
